var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VRow',[_c('VSpacer')],1),_c('VRow',_vm._l((Array.from({ length: 20 }, (_, index) => index + 1)),function(i){return _c('VCol',{key:i,attrs:{"cols":"12","xs":"12","md":"12","sm":"6","lg":"6"}},[_c('VSkeletonLoader',{attrs:{"type":"list-item-three-line"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }